import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Table, Collapse, Button, Spinner, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import './Biosecurity.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaChevronLeft, FaTrash, FaPlus } from 'react-icons/fa';
import MapView from '../Map/MapView';
import { useSearchParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select, { components } from 'react-select';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import NonMapView from '../ItemsView/NonMapView';
import ItemCommonTop from '../ItemPopup/ItemCommonTop';
import ItemCommonBottom from '../ItemPopup/ItemCommonBottom';
import ItemFooter from '../ItemPopup/ItemFooter';
import Validate from '../Validate/Validate';
import Action from '../Action/Action';
import ItemBasedAction from '../Action/ItemBasedAction';
import RiskSummary from '../ItemsView/RiskSummary';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap'; import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

const Biosecurity = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const { height, width } = useWindowDimensions();
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables"); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [loading, setLoading] = useState(true);
    const [itemList, setItemList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [saving, setSaving] = useState('');
    const [actionsCount, setActionsCount] = useState(0);
    const [imageUploadList, setImageUploadList] = useState([]);
    const [biosecurity, setBiosecurity] = useState({
        outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [], itemFieldTypes: [], lookUpList: [], SectionName: 'Biosecurity', Section: 'Biosecurity', isWizardCompleted: false,
        sectionObj: {}, sectionComment: '', outlineCenter: {}, farmCenterTypeModel: {}, outlineItemTypes: [], isMapOnly: false, isMapRisk: true
    });
    const [formErrors, setFormErrors] = useState({});
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 15,
        polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false, showLabel: false
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [isOpen, setIsOpen] = useState(false); const [isIconUp, setIsIconUp] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false); const [isIconUp1, setIsIconUp1] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const toggle1 = () => {
        setIsOpen1(!isOpen1)
        setIsIconUp1(!isIconUp1)
    };
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setBiosecurity({ ...biosecurity, sectionComment: value })
    }
    const { state } = useLocation();
    const navigate = useNavigate();
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: false, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({ itemTypeId: 0, isOpen: false, isIconUp: false });
    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [typeid, setTypeId] = useState(0);
    const [itemPopup, setItemPopup] = useState({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
    const [itemPopupHeader, setItemPopupHeader] = useState({
        page: 'Biosecurity', lmu: '', LMUId: 0, itemTypeName: '', LMUIds: '',
        itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: '' });
    const [itemPopupMaptype, setItemPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [itemPopupBiodiversity, setItemPopupBiodiversity] = useState({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
    const [itemPopupRisk, setItemPopupRisk] = useState({
        isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '',
        showEnterprise: true, category: '', significance: '', riskId: []
    });
    const [itemPopupAchievements, setItemPopupAchievements] = useState({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [itemPopupItemFeild, setItemPopupItemFeild] = useState({
        itemTypeId: 0,
        itemFieldTypes: []
    });
    const [actionPopup, setActionPopup] = useState({ isHavingItemBasedAction: false, showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [wholeFarmActionPopup, setWholeFarmActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
  
    const [riskLookupList, setRiskLookupList] = useState({ riskList: [], categoryList: [], enterpriseTypes: [], luenterpriseTypes: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], tempActivitySubGroups: [], LUEnterpriseTypes: [] });
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false });

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/biosecurity/GetBiosecurity/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setBiosecurity({
                ...biosecurity, outlineList: response.data.outlineList, itemList: response.data.itemList,
                itemTypes: response.data.itemTypes, uniqueItemTypes: response.data.uniqueItemTypes, itemFieldTypes: response.data.itemFeildList,
                isWizardCompleted: response.data.isFWFPCompleted, sectionObj: response.data.section,
                outlineCenter: response.data.outlineCenter, farmCenterTypeModel: response.data.farmCenterTypeModel, outlineItemTypes: response.data.outlineItemTypes, sectionComment: response.data.sectionComment
            });
            setActionsCount(response.data.actionCount);
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            setBiosecurityRisksAndVectorRows(response.data.biosecurityRisksAndVectorItems);
            setBiosecurityRiskManagementRows(response.data.biosecurityRiskManagementItems);
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setLoading(false);
            setItemPopupHeader({ ...itemPopupHeader, LMUIds: '' })
            setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: !response.data.isFWFPCompleted, isIconUp: !response.data.isFWFPCompleted })
            if (state != null) {
                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
                else {
                    editMapItemFromNavigation(itemId, response.data, navigateFrom)
                }
            }
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let navigateFrom = params.get('navigateFrom');
            if (navigateFrom == 'Actions') {
                let actionId = params.get('actionId');
                let itemId = params.get('itemId');
                let isWholeFarmAction = params.get('isWholeFarmAction');
                if (searchParams.has('actionId')) {
                    searchParams.delete('actionId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('itemId')) {
                    searchParams.delete('itemId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('isWholeFarmAction')) {
                    searchParams.delete('isWholeFarmAction');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('navigateFrom')) {
                    searchParams.delete('navigateFrom');
                    setSearchParams(searchParams);
                }
                if (isWholeFarmAction == 'true') {
                    handleNavigateOpenWholeActionPopup(itemId, actionId, response.data);
                }
                else {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }
    const resetValues = () => {
        setItemPopup({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
        setItemPopupHeader({ page: 'Biosecurity', lmu: '', LMUIds: '', itemTypeName: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: ''});
        setItemPopupMaptype({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
        setItemPopupBiodiversity({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
        setItemPopupRisk({
            isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance: ''
        });
        setItemPopupAchievements({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
        /*setFormErrors({});*/
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
        setImageUploadList([]);
    }
    /* Item select  and Clear*/
    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        const itemFieldTypesList = biosecurity.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == typeid);
        setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: typeid, itemFieldTypes: itemFieldTypesList });
    }

    const handleClearSelection = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: 0, itemFieldTypes: [] });
        window.location.reload(true);
    }

    const handleLMUChange = (event) => {
        var lus = '';
        let luArr = [];
        if (typeof event === 'object' && event.constructor === Object) {
            lus = event.value.toString();
        }
        else {
            event.forEach(lmu => {
                luArr.push(lmu.value);
            })
            lus = luArr.join(",");
        }

        if (lus == '') {
            setItemPopupRisk({ ...itemPopupRisk, isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance: '' });
        }
        else if (lus != '') {
            let selectedLUEnterpriseTypes = [];
            var LUEnterpriseTypes = [];//riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == value);
            
        }

        setItemPopupHeader({ ...itemPopupHeader, LMUIds: lus });
    }

    const handleItemEditPopup = (itemId) => {
        editMapItem([], itemId, false)
    }

    /*Item Delete*/
    const handleItemDeletePopup = (itemId) => {
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }

    const handleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await apiGet(
                '/api/biosecurity/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            });
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/biosecurity/GetBiosecurity/', {
            params: {
                farmId: farmId
            }
        }
        );
        setActionsCount(response.data.actionCount);
        setBiosecurity({
            ...biosecurity, itemList: response.data.itemList, outlineCenter: response.data.outlineCenter
        });
    }
    const handleItemPopupClose = () => {
        resetValues();
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';
        if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        else if (type == "polylineBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = biosecurity.itemList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setBiosecurity({ ...biosecurity, itemList: itemList });
    }

    const editMapItemFromNavigation = (itemId, biosecurity, navigateFrom) => {
        const itemDetails = biosecurity.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = biosecurity.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = biosecurity.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;

        const isBiodiversityReq = biosecurity.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
        if (itemDetails != null) {
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: [], farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive, isMapOnly: false });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: itemDetails.area, perimeter: itemDetails.length, coordinates: coordinates });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                Name: itemDetails.name, isDragged: false, Description: itemDetails.description, color: itemDetails.colour, itemTypeDescription: ItemDescription
            });
            setItemPopupBiodiversity({
                ...itemPopupBiodiversity, isVisible: isBiodiversityReq,
                isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment
            });
            let enterpriseTypes = []
            if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                let enterpriseTypesArray = [];

                enterpriseTypesArray = itemDetails.activityIds.split(',');

                riskLookupList.enterpriseTypes.map(type => {
                    if (enterpriseTypesArray.includes(String(type.value))) {
                        enterpriseTypes.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let ContaminantIds = []
            if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                let ContaminantIdsArray = [];

                ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                riskLookupList.contaminants.map(type => {
                    if (ContaminantIdsArray.includes(String(type.value))) {
                        ContaminantIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskDataGroups = []
            if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                let RiskDataGroupIdsArray = [];

                RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (RiskDataGroupIdsArray.includes(String(type.value))) {
                        riskDataGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let activityGroups = []
            if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                let ActivityGroupIdsArray = [];

                ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (ActivityGroupIdsArray.includes(String(type.value))) {
                        activityGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setRiskLookupList({
                ...riskLookupList, activitySubGroups: []
            });

            let myArrayFiltered = [];
            if (activityGroups != undefined && activityGroups.length > 0) {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }
            else {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }

            let activitySubGroups = []
            if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                let activitySubGroupIdsArray = [];

                activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                myArrayFiltered.map(type => {
                    if (activitySubGroupIdsArray.includes(String(type.value))) {
                        activitySubGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let categoryIds = []
            if (itemDetails.category != "" && itemDetails.category != null) {
                let categoryArray = [];

                categoryArray = itemDetails.category.split(',');

                riskLookupList.categoryList.map(type => {
                    if (categoryArray.includes(String(type.value))) {
                        categoryIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskIds = []
            if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                let riskArray = [];

                riskArray = itemDetails.riskIds.toString().split(',');

                riskLookupList.riskList.map(type => {
                    if (riskArray.includes(String(type.value))) {
                        riskIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setItemPopupRisk({
                isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                category: categoryIds, significance: itemDetails.significance, riskId: riskIds
            });

            let selectedLUEnterpriseTypes = [];
            if (itemDetails.lmuId != 0) {
                var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                if (LUEnterpriseTypes.length != 0) {
                    let LUEnterpriseTypesArray = [];

                    LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return LUEnterpriseTypesArray.includes(String(el.value))
                    });
                }
            }

            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

            let isExpand = false;
            if (navigateFrom == "Achievements")
                isExpand = true
            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: isExpand });

            const itemFieldTypesList = biosecurity.itemFeildList.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
            setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

            setToggleItemTypeState({ itemTypeId: itemDetails.itemTypeId, isOpen: true, isIconUp: true });
            setToggleItemState({ itemId: itemId, isOpen: true, isIconUp: true });
        }
    } 
    /*Item Edit and Submit*/
    const editMapItem = (mapItem, itemId, isDragged) => {
        const itemDetails = biosecurity.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = biosecurity.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = biosecurity.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;
        if (isDragged) {
            coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
        }
        let area = 0.0, perimeter = 0.0;
        if (itemDetails.isEdited == true) {
            if (itemDetails.mapMarkerType == "polygon") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })
                const tempPolygon = new window.google.maps.Polygon({
                    paths: positions
                });

                let path = tempPolygon.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            }
            else if (itemDetails.mapMarkerType == "polyline") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })

                const tempPolyline = new window.google.maps.Polyline({
                    paths: positions
                });

                let path = tempPolyline.paths;
                area = itemDetails.area;
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                if (path.length <= 1) {
                    toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    resetValues();
                    return false;
                }
            }
        }
        else {
            area = itemDetails.area;
            perimeter = itemDetails.length;
        }

        const isBiodiversityReq = biosecurity.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
        if (itemDetails != null) {
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive, isMapOnly: false });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                Name: itemDetails.name, isDragged: isDragged, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription
            });
            setItemPopupBiodiversity({
                ...itemPopupBiodiversity, isVisible: isBiodiversityReq,
                isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment
            });

            let enterpriseTypes = []
            if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                let enterpriseTypesArray = [];

                enterpriseTypesArray = itemDetails.activityIds.split(',');

                riskLookupList.enterpriseTypes.map(type => {
                    if (enterpriseTypesArray.includes(String(type.value))) {
                        enterpriseTypes.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let categoryIds = []
            if (itemDetails.category != "" && itemDetails.category != null) {
                let categoryArray = [];

                categoryArray = itemDetails.category.split(',');

                riskLookupList.categoryList.map(type => {
                    if (categoryArray.includes(String(type.value))) {
                        categoryIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let ContaminantIds = []
            if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                let ContaminantIdsArray = [];

                ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                riskLookupList.contaminants.map(type => {
                    if (ContaminantIdsArray.includes(String(type.value))) {
                        ContaminantIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskDataGroups = []
            if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                let RiskDataGroupIdsArray = [];

                RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (RiskDataGroupIdsArray.includes(String(type.value))) {
                        riskDataGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let activityGroups = []
            if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                let ActivityGroupIdsArray = [];

                ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (ActivityGroupIdsArray.includes(String(type.value))) {
                        activityGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setRiskLookupList({
                ...riskLookupList, activitySubGroups: []
            });

            let myArrayFiltered = [];
            if (activityGroups != undefined && activityGroups.length > 0) {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }
            else {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }

            let activitySubGroups = []
            if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                let activitySubGroupIdsArray = [];

                activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                myArrayFiltered.map(type => {
                    if (activitySubGroupIdsArray.includes(String(type.value))) {
                        activitySubGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskIds = []
            if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                let riskArray = [];

                riskArray = itemDetails.riskIds.toString().split(',');

                riskLookupList.riskList.map(type => {
                    if (riskArray.includes(String(type.value))) {
                        riskIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setItemPopupRisk({
                isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                category: categoryIds, significance: itemDetails.significance, riskId: riskIds
            });

            let selectedLUEnterpriseTypes = [];
            if (itemDetails.lmuId != 0) {
                var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                if (LUEnterpriseTypes.length != 0) {
                    let LUEnterpriseTypesArray = [];

                    LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return LUEnterpriseTypesArray.includes(String(el.value))
                    });
                }
            }

            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: false });

            const itemFieldTypesList = biosecurity.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
            setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });



        }
    }

    /*handle Toggle for nonMap View*/
    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTypeTogole = (itemTypeId, isOpen, isIconUp,) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTogole = (itemId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleLMUSelectChange = (event) => {
        const { name, value, checked, type } = event.target;
        setLargeEnterpriseDetails({ ...largeEnterpriseDetails, [name]: type == 'checkbox' ? checked : value });
    }

    /*Item Add and Submit*/
    const addMapItem = (mapItem, maptype) => {
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        var selectedItemType = biosecurity.itemTypes.filter(item => item.id == typeid)[0];
        const ItemTypeName = selectedItemType.name;
        const isBiodiversityReq = selectedItemType.isBiodiversityReq == true ? true : false;
        let lmuId = largeEnterpriseDetails.selectedLMUId;
        const defaultColour = selectedItemType.defaultColour != null && selectedItemType.defaultColour != '' ? selectedItemType.defaultColour : "#21b546";

        /***********LMU Identification*************/
        if (maptype == 'marker') {
            largeEnterpriseDetails.LMUList.map((obj) => {
                const outlineCoordinates = obj.mapCoordinates.split(':');
                const outlinepositions = [];
                outlineCoordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    outlinepositions.push(pos);
                })
                const outlinePolygon = new window.google.maps.Polygon({
                    paths: outlinepositions
                });
                const pos = { lat: mapItem.getPosition().lat(), lng: mapItem.getPosition().lng() }

                const inside = window.google.maps.geometry.poly.containsLocation(
                    pos,
                    outlinePolygon
                ) ? true : false;
                if (inside) {
                    lmuId = obj.id;
                }
            });
        }
        /***********LMU Identification*************/

        if (maptype == 'marker') {

            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
        }
        else if (maptype == 'polygon') {
            path = mapItem.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        else if (maptype == 'polyline') {
            path = mapItem.getPath();
            area = 0;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
            if (path.getArray().length <= 1) {
                toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                resetValues();
                return false;
            }
        }

        let selectedLUEnterpriseTypes = [];
        //if (lmuId != 0) {
        //    var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == lmuId);
        //    if (LUEnterpriseTypes.length != 0) {
        //        let LUEnterpriseTypesArray = [];

        //        LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

        //        selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
        //            return LUEnterpriseTypesArray.includes(String(el.value))
        //        });
        //        if (selectedLUEnterpriseTypes.length == 0) {
        //            selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
        //                return el.label == 'N/A'
        //            });
        //        }
        //    }
        //}

        /*setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes })*/
        setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0, itemId: 0, markertype: maptype, canArchive: true });
        setItemPopupMaptype({ ...itemPopupMaptype, markertype: maptype, area: area, perimeter: perimeter, coordinates: coordinates });
        setItemPopupHeader({ ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: typeid, LMUId: lmuId, LMUIds: lmuId.toString(), Name: '', isDragged: false, Description: '', color: defaultColour, isEdited: false, itemTypeDescription: selectedItemType.itemDescription });
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq });
        setItemPopupAchievements({ ...itemPopupAchievements, isExpand: false });
        setImageUploadList([]);
    }

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }

    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))//biosecurity.sectionComment
            };
            const response = await apiPost(
                '/api/biosecurity/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }

    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/biosecurity/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

        } catch (err) {
            console.log(err);
        }
    }

    const [savingSectionComment, setSavingSectionComment] = useState('');

    const [biosecurityRisksAndVectorRows, setBiosecurityRisksAndVectorRows] = useState([]);
    const [biosecurityRiskManagementRows, setBiosecurityRiskManagementRows] = useState([]);
    const handleRiskNameChange = idx => e => {
        const tempRows = [...biosecurityRisksAndVectorRows];
        tempRows[idx].riskName = e.target.value;
        setBiosecurityRisksAndVectorRows(tempRows);
    };
    const handleTitleChange = idx => e => {
        const tempRows = [...biosecurityRiskManagementRows];
        tempRows[idx].title = e.target.value;
        setBiosecurityRiskManagementRows(tempRows);
    };
    const handleDescriptionChange = idx => e => {
        const tempRows = [...biosecurityRiskManagementRows];
        tempRows[idx].description = e.target.value;
        setBiosecurityRiskManagementRows(tempRows);
    };
    const handleAssociatedwithChange = idx => e => {
        const tempRows = [...biosecurityRiskManagementRows];
        tempRows[idx].associatedwith = e;
        setBiosecurityRiskManagementRows(tempRows);
    };
    const handleRiskDescriptionChange = idx => e => {
        const tempRows = [...biosecurityRisksAndVectorRows];
        tempRows[idx].riskDescription = e.target.value;
        setBiosecurityRisksAndVectorRows(tempRows);
    };
    const handleRiskAssociatedwithChange = idx => e => {
        const tempRows = [...biosecurityRisksAndVectorRows];
        tempRows[idx].riskAssociatedwith = e;
        setBiosecurityRisksAndVectorRows(tempRows);
    };
    const handleBiosecurityRisksAndVectorRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...biosecurityRisksAndVectorRows]
        tempRows.splice(idx, 1)
        setBiosecurityRisksAndVectorRows(tempRows);
    }
    const handleBiosecurityRiskManagementRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...biosecurityRiskManagementRows]
        tempRows.splice(idx, 1)
        setBiosecurityRiskManagementRows(tempRows);
    }
    const [savingBiosecurityRisksAndVectors, setSavingBiosecurityRisksAndVectors] = useState('');
    const handleBiosecurityRisksAndVectorRowsSubmit = async (e) => {
        e.preventDefault()
        setSavingBiosecurityRisksAndVectors(true);
        let tempContactRows = [...biosecurityRisksAndVectorRows];
        let form = {
            FarmId: farmId,
            BiosecurityRisksAndVectors: [],
            UserId: userId
        }
        for (var i = 0; i < tempContactRows.length; i++) {
            var obj = {};
            obj.Id = tempContactRows[i].id;
            obj.FarmId = farmId;
            obj.RiskName = tempContactRows[i].riskName;
            obj.RiskDescription = tempContactRows[i].riskDescription;
            obj.RiskAssociatedwith = tempContactRows[i].riskAssociatedwith;
            form.BiosecurityRisksAndVectors.push(obj);
        }
        const response = await apiPost(
            '/api/biosecurity/SaveBiosecurityRisksAndVectors/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("Biosecurity Risks And Vectors Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingBiosecurityRisksAndVectors(false);
                setBiosecurityRisksAndVectorRows(response.data.content);
            }
        }
    };
    const [savingBiosecurityRiskManagement, setSavingBiosecurityRiskManagement] = useState('');
    const handleBiosecurityRiskManagementRowsSubmit = async (e) => {
        e.preventDefault()
        setSavingBiosecurityRiskManagement(true);
        let tempContactRows = [...biosecurityRiskManagementRows];
        let form = {
            FarmId: farmId,
            BiosecurityRiskManagement: [],
            UserId: userId
        }
        for (var i = 0; i < tempContactRows.length; i++) {
            var obj = {};
            obj.Id = tempContactRows[i].id;
            obj.FarmId = farmId;
            obj.Title = tempContactRows[i].title;
            obj.Description = tempContactRows[i].description;
            obj.Associatedwith = tempContactRows[i].associatedwith;
            form.BiosecurityRiskManagement.push(obj);
        }
        const response = await apiPost(
            '/api/biosecurity/SaveBiosecurityRiskManagement/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("Biosecurity Risk Management Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingBiosecurityRiskManagement(false);
                setBiosecurityRiskManagementRows(response.data.content);
            }
        }
    };
    const handleBiosecurityRisksAndVectorRowsAddRow = () => {
        const item = {
            id: 0, riskName: '', riskDescription: '', riskAssociatedwith:[]
        };
        setBiosecurityRisksAndVectorRows([...biosecurityRisksAndVectorRows, item]);
    };
    const handleBiosecurityRiskManagementRowsAddRow = () => {
        const item = {
            id: 0, title: '', description: '', associatedwith: ''
        };
        setBiosecurityRiskManagementRows([...biosecurityRiskManagementRows, item]);
    };
    var associatedwithList = [];
    var obj = {};
    obj.label = 'Pests'; obj.value = 'Pests';
    associatedwithList.push(obj);
    var obj1 = {};
    obj1.label = 'Weeds'; obj1.value = 'Weeds';
    associatedwithList.push(obj1);
    var obj2 = {};
    obj2.label = 'Diseases'; obj2.value = 'Diseases';
    associatedwithList.push(obj2);

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error("ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    /*ItemPopup value change Handle*/
    const handleItemPopupHeaderChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setFormErrors({});
        setItemPopupHeader({ ...itemPopupHeader, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemPopupBiodiversity = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemPopupRisk = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'isRisk' && value == 'Yes') {
            setFormErrors({});
            const errors = {};
            if (itemPopupHeader.LMUIds == '') {
                errors.luid = "Please select LU";
                setFormErrors(errors);
            }
            else {
                setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else if (name == 'isRisk' && value == 'No') {
            setItemPopupRisk({ ...itemPopupRisk, category: '', significance: '', isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: true });
        }
        else {
            setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
        }
    }

    const handleMultiSelectEnterpriseChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, enterprises: e });
    }
    const handleMultiSelectRiskChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskId: e });
    }
    const handleMultiSelectContaminantChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, contaminants: e });
    }
    const handleMultiSelectCategoryChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, category: e });
    }
    const handleMultiSelectRiskDataGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskDataGroups: e });
    }

    const handleMultiSelectActivityGroupChange = (e) => {

        setRiskLookupList({
            ...riskLookupList, activitySubGroups: []
        })
        var selectedActivitySubGroups = [];
        let myArrayFiltered = [];
        if (itemPopupRisk.activitySubGroups != undefined && itemPopupRisk.activitySubGroups.length > 0) {
            selectedActivitySubGroups = itemPopupRisk.activitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setRiskLookupList({
            ...riskLookupList, activitySubGroups: myArrayFiltered
        })
        setItemPopupRisk({ ...itemPopupRisk, activityGroups: e, activitySubGroups: selectedActivitySubGroups });
    }

    const handleMultiSelectActivitySubGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, activitySubGroups: e });
    }

    const handleItemPopupAchievements = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupAchievements({ ...itemPopupAchievements, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemSubmit = async (event) => {
        setFormErrors({});
        setSaving(true);
        const errors = {};
        let category = '';
        let enterprises = '';
        let contaminants = '';
        let riskDataGroups = '';
        let activityGroups = '';
        let activitySubGroups = '';
        var RiskId = 0;
        var RiskIds = '';
        if (itemPopupRisk.isRisk == "Yes") {
            if (itemPopupRisk.riskId == 0 || itemPopupRisk.riskId == null || itemPopupRisk.riskId == undefined) {
                errors.riskSelection = "This is mandatory!";
            }
            else {
                if (typeof itemPopupRisk.riskId === 'object' && itemPopupRisk.riskId.constructor === Object) {
                    RiskIds = itemPopupRisk.riskId.value.toString();
                }
                else if (Array.isArray(itemPopupRisk.riskId)) {
                    let riskArr = [];
                    itemPopupRisk.riskId.forEach(type => {
                        riskArr.push(type.value);
                    })
                    var riskValue = riskArr.join(",");
                    RiskIds = riskValue;
                }
            }
        }
        if (itemPopupHeader.LMUIds == null || itemPopupHeader.LMUIds == '' || itemPopupHeader.LMUIds == undefined || itemPopupHeader.LMUIds == '0') {
            errors.luid = "This is mandatory!";
        }
        setFormErrors(errors);

        if (Object.keys(errors).length == 0) {
            let form = {
                Id: itemPopup.id,
                MapMarkerType: itemPopup.markertype,
                FarmId: itemPopup.farmId,
                ItemId: itemPopup.itemId,
                Name: itemPopupHeader.Name,
                IsDragged: itemPopupHeader.isDragged,
                Description: itemPopupHeader.Description,
                Colour: itemPopupHeader.color,
                LMUId: itemPopupHeader.LMUId,
                ItemTypeId: itemPopupHeader.itemTypeId,
                Area: itemPopupMaptype.area,
                Length: itemPopupMaptype.perimeter,
                MapCoordinates: itemPopupMaptype.coordinates,
                IsAddsToBioDiversity: itemPopupBiodiversity.isItemToBiodiversity,
                BioDiversityComment: itemPopupBiodiversity.biodiversityComment,
                IsItemHaveAnyRisk: itemPopupRisk.isRisk,
                RiskDescription: itemPopupRisk.riskComment,
                IsAchievementOfNote: itemPopupAchievements.isAchievementsNotes,
                AchievementOfNoteComments: itemPopupAchievements.achievementsComment,
                userId: userId,
                IsEdited: itemPopupHeader.isEdited,
                ActivityIds: enterprises,
                ContaminantIds: contaminants,
                RiskDataGroupIds: riskDataGroups,
                ActivityGroupIds: activityGroups,
                ActivitySubGroupIds: activitySubGroups,
                RiskLikelihood: itemPopupRisk.likelihood,
                RiskImpact: itemPopupRisk.impact,
                Category: category,
                Significance: itemPopupRisk.significance,
                LMUIds: itemPopupHeader.LMUIds,
                RiskIds: RiskIds, ImageUploadList: []
            }
            for (var i = 0; i < imageUploadList.length; i++) {
                var obj = {};
                obj.Id = imageUploadList[i].id;
                obj.ImageDetail = imageUploadList[i].imageDetail;
                obj.ImageName = imageUploadList[i].imageName;
                obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
                obj.ImagePath = imageUploadList[i].imagePath;
                form.ImageUploadList.push(obj);
            }
            if (!Validate(form)) {

                try {
                    const response = await apiPost(
                        '/api/biosecurity/UpdateBiosecurity/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });
                    if (response.data != null) {
                        await refreshItemDetails();
                        setSaving(false);
                        toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        handleItemPopupClose();
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
            else {
                setSaving(false);
            }
        }
        else {
            setSaving(false);
        }
    }

    /*Item- Action Popup handle*/
    const handleOpenActionPopup = (itemId, actionId) => {
        const itemDetails = biosecurity.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ isHavingItemBasedAction: itemDetails.isHavingItemBasedAction, showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleOpenWholeActionPopup = (itemId, actionId) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: biosecurity.outlineCenter.itemTypeId, itemName: 'Map Centre', actionId: actionId });
    };

    const handleActionClose = async () => {
        setActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleWholeActionClose = () => {
        setWholeFarmActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, biosecurity) => {
        const itemDetails = biosecurity.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };
    const handleNavigateOpenWholeActionPopup = (itemId, actionId, biosecurity) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: biosecurity.outlineCenter.itemTypeId, itemName: 'NA', actionId: actionId });
    };

    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }

    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={biosecurity}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}
                addMapItem={addMapItem}
                editMapItem={editMapItem}
                handleMapItemEdited={handleMapItemEdited}
            >
            </MapView>
        )
    }, [biosecurity, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={biosecurity.isWizardCompleted} Section={biosecurity.Section}
                itemTypesList={biosecurity.itemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
            >
            </ItemTypeListViewForMap>
        )
    }, [biosecurity, largeEnterpriseDetails, biosecurity.sectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, biosecurity.outlineCenter])

    const nonMapView = useMemo(() => {
        return (
            <NonMapView show_HistoricalActions={show_HistoricalActions} itemModel={biosecurity} handleSectionCommentChange={handleSectionCommentChange}
                toggleItemTypeListState={toggleItemTypeListState}
                toggleItemTypeState={toggleItemTypeState}
                toggleItemState={toggleItemState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemEditPopup={handleItemEditPopup}
                handleItemDeletePopup={handleItemDeletePopup}
                sectionObj={biosecurity.sectionObj}
                largeEnterpriseDetails={largeEnterpriseDetails}
                handleLMUSelectChange={handleLMUSelectChange}
                handleItemTypeListTogole={handleItemTypeListTogole}
                handleItemTypeTogole={handleItemTypeTogole}
                handleItemTogole={handleItemTogole}
                handleItemHighlight={handleItemHighlight} outlineCenter={biosecurity.outlineCenter}
                handleOpenActionPopup={handleOpenActionPopup}
                handleOpenWholeActionPopup={handleOpenWholeActionPopup}
            ></NonMapView>
        )
    }, [biosecurity, largeEnterpriseDetails, biosecurity.sectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, biosecurity.outlineCenter])

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{biosecurity.SectionName}</h3></Col>
                { !loading &&
                    <Col>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biosecurity.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biosecurity.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biosecurity.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                <Row className="map-layer" style={{ marginTop: '5px' }}>
                                    <Col>
                                        <Row>
                                            <Col sm="3"> {toggleSwitch == 'map & details' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                                </Button>
                                            }
                                                {toggleSwitch == 'map' &&
                                                    <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                    </Button>
                                                }
                                            </Col>
                                            <Col sm="1"></Col>
                                            <Col sm="8">
                                                <div className="map-item-edit-div">
                                                    <Label className="map-checkbox-label">Show LU layer</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={largeEnterpriseDetails.isSmallEnterpriseShow} onChange={(e) => setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isSmallEnterpriseShow: !largeEnterpriseDetails.isSmallEnterpriseShow })} name="isSmallEnterpriseShow" id="isSmallEnterpriseShow" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Edit Item</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                    <Label className="map-checkbox-label">Show Label</Label>
                                                    <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                                </div>
                                            </Col>
                                        </Row>
                                        {mapView}
                                    </Col>
                                </Row>
                            </Col>
                            <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw", marginTop: "15px" }}>
                                <br />
                                <Row>
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                         
                                                            <Row>
                                                                <Col>
                                                                    <Row>
                                                                        <Col>
                                                                            <h4>Biosecurity </h4>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <Label className="info-text">Click an icon and place it on the map to mark biosecurity areas and infrastructure.</Label>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <hr />
                                                            <Row>
                                                                <Col>
                                                                    {itemTypeListView}
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-8px" }}>
                                <Row style={{ marginTop: '10px' }} >
                                    <Col >
                                        {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {
                                            !loading && <Button style={{ marginLeft: "0.5vw" }} onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summary">Risk and Actions summary</Button>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                                               <Row>
                                                                   <Col>
                                                                       <Row>
                                                                           <Col>
                                                                            <h4>Biosecurity </h4>
                                                                           </Col>
                                                                       </Row>
                                                                       <Row>
                                                                           <Col>
                                                                            <Label className="info-text">Click an icon and place it on the map to mark biosecurity areas and infrastructure.</Label>
                                                                           </Col>
                                                                       </Row>
                                                                   </Col>
                                                               </Row>
                                                                
                                                            <hr />
                                                            {show_SectionComment &&
                                                                <>
                                                                    <Row style={{ marginTop: "0.5vh" }}>
                                                                        <Col sm="12">
                                                                            <FormGroup>
                                                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                                                                <Editor handlePastedText={() => false}
                                                                                    defaultEditorState={editorState}
                                                                                    onEditorStateChange={setEditorState}
                                                                                    wrapperClassName="wrapper-class"
                                                                                    editorClassName="editor-class"
                                                                                    toolbarClassName="toolbar-class"
                                                                                    toolbar={
                                                                                        {
                                                                                            options: ['inline'], inline: {
                                                                                                inDropdown: false,
                                                                                                options: ['bold', 'italic', 'underline'],
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                />
                                                                            </FormGroup>

                                                                        </Col>
                                                                        <Col sm="12">
                                                                            {savingSectionComment ?
                                                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                                                    <Row>
                                                                                        <Col sm="8">
                                                                                            <span>
                                                                                                {' '}Saving
                                                                                            </span>
                                                                                        </Col>
                                                                                        <Col sm="4">
                                                                                            <Spinner size="sm">
                                                                                                Saving...
                                                                                            </Spinner>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Button>
                                                                                :
                                                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                                                    Save
                                                                                </Button>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <br />
                                                                </>
                                                            }
                                                            <Row>
                                                                <Col>
                                                                    {nonMapView}
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <br />
                                <Row >
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardHeader className="header" onClick={toggle}>
                                                <Row>
                                                    <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Key Biosecurity Risks and Risk Vectors
                                                        </span>
                                                    </Col>
                                                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                </Row>
                                            </CardHeader>
                                            <Collapse isOpen={isOpen}>
                                                <CardBody>
                                                    <Row>
                                                        <Col>
                                                            <span><b>Identify risks based on occurrence likelihood and business impact. Include animals, people, vehicles, machinery, and external feed.</b>
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                <>
                                                                    <button style={{ float:"right" }} onClick={handleBiosecurityRisksAndVectorRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                                                        <FaPlus />
                                                                    </button>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="12">
                                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-left"> Risk Name </th>
                                                                        <th className="text-left"> Risk Description </th>
                                                                        <th className="text-left"> Associated with </th>
                                                                        <th />
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-left">
                                                                    {biosecurityRisksAndVectorRows.map((item, idx) => (
                                                                        <tr id="addr0" key={idx}>
                                                                            <td style={{ display: "none" }}>{biosecurityRisksAndVectorRows[idx].id}</td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="riskName"
                                                                                    value={biosecurityRisksAndVectorRows[idx].riskName}
                                                                                    onChange={handleRiskNameChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <textarea
                                                                                    type="text"
                                                                                    name="riskDescription"
                                                                                    value={biosecurityRisksAndVectorRows[idx].riskDescription}
                                                                                    onChange={handleRiskDescriptionChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                {/*<Input type="select" value={biosecurityRisksAndVectorRows[idx].riskAssociatedwith} onChange={handleRiskAssociatedwithChange(idx)} name="riskAssociatedwith" id="riskAssociatedwith">*/}
                                                                                {/*    <option key={uuid()} value="Select">Select</option>*/}
                                                                                {/*    <option key={uuid()} value="Pests">Pests</option>*/}
                                                                                {/*    <option key={uuid()} value="Weeds">Weeds</option>*/}
                                                                                {/*    <option key={uuid()} value="Diseases">Diseases</option>*/}
                                                                                {/*</Input>*/}
                                                                                <Select
                                                                                    id="riskAssociatedwith"
                                                                                    name="riskAssociatedwith"
                                                                                    closeMenuOnSelect={false}
                                                                                    className="dropdown"
                                                                                    placeholder="Select"
                                                                                    defaultValue={biosecurityRisksAndVectorRows[idx].riskAssociatedwith}
                                                                                    options={associatedwithList}
                                                                                    onChange={handleRiskAssociatedwithChange(idx)}
                                                                                    isClearable={false} isMulti hideSelectedOptions={false}
                                                                                    components={{
                                                                                        Option
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "5%" }}>
                                                                                {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                    <>
                                                                                    <button style={{ float: "right" }} onClick={handleBiosecurityRisksAndVectorRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                            <FaTrash />
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                <>
                                                                {savingBiosecurityRisksAndVectors ?
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRisksAndVectorRowsSubmit}
                                                                            color="success"
                                                                            disabled
                                                                        >
                                                                            <Row>
                                                                                <Col sm="6">
                                                                                    <span>
                                                                                        {' '}Saving
                                                                                    </span>
                                                                                </Col>
                                                                                <Col sm="6">
                                                                                    <Spinner size="sm">
                                                                                        Saving...
                                                                                    </Spinner>
                                                                                </Col>
                                                                            </Row>
                                                                        </Button>
                                                                        :
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRisksAndVectorRowsSubmit} color="success" size="sm">
                                                                            Save
                                                                        </Button>
                                                                    }
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                </Row>
                                <br />
                                <Row >
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardHeader className="header" onClick={toggle1}>
                                                <Row>
                                                    <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Processes for Risk Management or minimisation
                                                    </span>
                                                    </Col>
                                                    <Col sm="1" className="toggleoutline_lt">{isIconUp1 ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                </Row>
                                            </CardHeader>
                                            <Collapse isOpen={isOpen1}>
                                                <CardBody>
                                                    <Row>
                                                        <Col>
                                                            <span><b>Identify how the introduced risks are managed or minimised</b>
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'Admin' || isAddEditItem == 'true') &&
                                                                <>
                                                                <button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                                                        <FaPlus />
                                                                    </button>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="12">
                                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-left"> Title </th>
                                                                        <th className="text-left"> Description </th>
                                                                        <th className="text-left"> Associated with </th>
                                                                        <th />
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-left">
                                                                    {biosecurityRiskManagementRows.map((item, idx) => (
                                                                        <tr id="addr0" key={idx}>
                                                                            <td style={{ display: "none" }}>{biosecurityRiskManagementRows[idx].id}</td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="title"
                                                                                    value={biosecurityRiskManagementRows[idx].title}
                                                                                    onChange={handleTitleChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <textarea
                                                                                    type="text"
                                                                                    name="description"
                                                                                    value={biosecurityRiskManagementRows[idx].description}
                                                                                    onChange={handleDescriptionChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <Select
                                                                                    id="associatedwith"
                                                                                    name="associatedwith"
                                                                                    closeMenuOnSelect={false}
                                                                                    className="dropdown"
                                                                                    placeholder="Select"
                                                                                    defaultValue={biosecurityRiskManagementRows[idx].associatedwith}
                                                                                    options={associatedwithList}
                                                                                    onChange={handleAssociatedwithChange(idx)}
                                                                                    isClearable={false} isMulti hideSelectedOptions={false}
                                                                                    components={{
                                                                                        Option
                                                                                    }}
                                                                                />
                                                                                {/*<Input type="select" value={biosecurityRiskManagementRows[idx].associatedwith} onChange={handleAssociatedwithChange(idx)} name="associatedwith" id="associatedwith">*/}
                                                                                {/*    <option key={uuid()} value="Select">Select</option>*/}
                                                                                {/*    <option key={uuid()} value="Pests">Pests</option>*/}
                                                                                {/*    <option key={uuid()} value="Weeds">Weeds</option>*/}
                                                                                {/*    <option key={uuid()} value="Diseases">Diseases</option>*/}
                                                                                {/*</Input>*/}
                                                                            </td>
                                                                            <td style={{ width: "5%" }}>
                                                                                {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                    <>
                                                                                        <button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                            <FaTrash />
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                <>
                                                                {savingBiosecurityRiskManagement ?
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsSubmit}
                                                                            color="success"
                                                                            disabled
                                                                        >
                                                                            <Row>
                                                                                <Col sm="6">
                                                                                    <span>
                                                                                        {' '}Saving
                                                                                    </span>
                                                                                </Col>
                                                                                <Col sm="6">
                                                                                    <Spinner size="sm">
                                                                                        Saving...
                                                                                    </Spinner>
                                                                                </Col>
                                                                            </Row>
                                                                        </Button>
                                                                        :
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsSubmit} color="success" size="sm">
                                                                            Save
                                                                        </Button>
                                                                    }
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        {
                                            biosecurity.sectionObj.isDocumentUploadReq && <Documents refid={biosecurity.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
            }
            <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="itemPopup">
                <Form>
                    <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item</ModalHeader>
                    <ModalBody>
                        <ItemCommonTop setFormErrors={setFormErrors} Section={biosecurity.Section} handleLMUChange={handleLMUChange} itemPopupHeader={itemPopupHeader} itemPopupMaptype={itemPopupMaptype} itemPopupBiodiversity={itemPopupBiodiversity} itemPopupRisk={itemPopupRisk}
                            largeEnterpriseDetails={largeEnterpriseDetails} formErrors={formErrors} riskLookupList={riskLookupList}
                            handleItemPopupHeaderChange={handleItemPopupHeaderChange}
                            handleItemPopupBiodiversity={handleItemPopupBiodiversity}
                            handleItemPopupRisk={handleItemPopupRisk} handleMultiSelectRiskChange={handleMultiSelectRiskChange}
                            handleMultiSelectEnterpriseChange={handleMultiSelectEnterpriseChange}
                            handleMultiSelectContaminantChange={handleMultiSelectContaminantChange}
                            handleMultiSelectRiskDataGroupChange={handleMultiSelectRiskDataGroupChange}
                            handleMultiSelectActivityGroupChange={handleMultiSelectActivityGroupChange}
                            handleMultiSelectActivitySubGroupChange={handleMultiSelectActivitySubGroupChange}
                            handleMultiSelectCategoryChange={handleMultiSelectCategoryChange} setRiskLookupList={setRiskLookupList} setItemPopupRisk={setItemPopupRisk}
                        ></ItemCommonTop>
                        <ItemCommonBottom setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} itemPopup={itemPopup} itemPopupAchievements={itemPopupAchievements}
                            handleItemPopupAchievements={handleItemPopupAchievements}></ItemCommonBottom>
                    </ModalBody>

                    <ItemFooter saving={saving} itemPopup={itemPopup}
                        handleItemDeletePopup={handleItemDeletePopup}
                        handleItemSubmit={handleItemSubmit}
                        handleItemPopupClose={handleItemPopupClose}
                        handleOpenActionPopup={handleOpenActionPopup}>
                    </ItemFooter>
                </Form>
            </Modal>
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Archive the item</ModalHeader>
                <ModalBody>
                    Do you want to archive the item ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            {actionPopup.showActionPopup && !actionPopup.isHavingItemBasedAction && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={biosecurity.itemList} redirectPage="/biosecurity" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={biosecurity.Section} sectionId={biosecurity.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={biosecurity.itemTypes} itemTypeDisabled={true} wholeFarmAction={false} ></Action>}

            {actionPopup.showActionPopup && actionPopup.isHavingItemBasedAction && <ItemBasedAction width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={biosecurity.itemList} redirectPage="/biosecurity" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={biosecurity.Section} sectionId={biosecurity.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={biosecurity.itemTypes} itemTypeDisabled={true} wholeFarmAction={false} ></ItemBasedAction>}

            {wholeFarmActionPopup.showActionPopup && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={biosecurity.itemList} redirectPage="/biosecurity" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleWholeActionClose} itemTypeId={wholeFarmActionPopup.itemTypeId} sectionName={biosecurity.Section} sectionId={biosecurity.itemTypes[0].sectionId} itemId={wholeFarmActionPopup.itemId} itemName={wholeFarmActionPopup.itemName}
                showActionPopupModal={wholeFarmActionPopup.showActionPopup} actionId={wholeFarmActionPopup.actionId} itemTypeSelect={biosecurity.outlineItemTypes} itemTypeDisabled={true} wholeFarmAction={true}></Action>}

            {riskSummaryPopup.showriskSummary && <RiskSummary section={biosecurity.sectionObj} sectionId={biosecurity.itemTypes[0].sectionId} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}

        </div>
    )
}
export default Biosecurity;